import { PhotoshopController } from "../../../../photoshopController.js";
import { ParametersWidget } from "./parameterWidget.js";
import * as noUiSlider from 'nouislider';

declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class SelectiveCorrectionParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = SelectiveCorrectionParameterWidget.html();
        super.initEvent();

        const scColorsElement = document.getElementById("sc-colors");
        if (scColorsElement) {
            scColorsElement.addEventListener("change", function (event) {
                this.sc_colorsOnChange();
            }.bind(this));
        }

        const scRelativeInput = document.getElementById("sc-relative-input");
        if (scRelativeInput) {
            scRelativeInput.addEventListener("change", function (event) {
                this.sc_relative_inputOnChange((event.currentTarget as HTMLInputElement).value);
            }.bind(this));
        }

        const scAbsoluteInput = document.getElementById("sc-absolute-input");
        if (scAbsoluteInput) {
            scAbsoluteInput.addEventListener("change", function (event) {
                this.sc_relative_inputOnChange((event.currentTarget as HTMLInputElement).value);
            }.bind(this));
        }

        this.updateModel();
        this.initializeSelectiveCorrectionRange();
    }

    static html() {
        return super.header() + `
        <div id="selectiveCorrection" style="display: none; padding: 10px;">
            <h4 class="center-align">Correction sélective</h4>
            <div class="col s12 divider"></div>
            <div class="col s12" style="text-align: center">
                <select id="sc-colors">
                    <option value="red">Rouge</option>
                    <option value="yellow">Jaune</option>
                    <option value="green">Vert</option>
                    <option value="cyan">Cyan</option>
                    <option value="blue">Bleu</option>
                    <option value="magenta">Magenta</option>
                    <option value="white">Blanc</option>
                    <option value="neutral">Gris</option>
                    <option value="black">Noir</option>
                </select>
            </div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Cyan</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="sc-cyan-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="sc-cyan-input" type="number">
                </div>
            </div>
            <div class="col s12 divider"></div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Magenta</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="sc-magenta-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="sc-magenta-input" type="number">
                </div>
            </div>
            <div class="col s12 divider"></div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Jaune</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="sc-yellow-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="sc-yellow-input" type="number">
                </div>
            </div>
            <div class="col s12 divider"></div>
            <div class="col s9 no-padding left" style="margin-top: 10px;">
                <div class="left">Noir</div>
            </div>
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">
                <div class="col s9 no-padding">
                    <div id="sc-black-range" class="col s12 row"></div>
                </div>
                <div class="col s3">
                    <input id="sc-black-input" type="number">
                </div>
            </div>
            <div class="col s12 no-padding">
                <p>
                    <label>
                        <input id="sc-relative-input" name="method" value="relative" type="radio">
                        <span>Relative</span>
                    </label>
                    <label>
                        <input id="sc-absolute-input" name="method" value="absolute" type="radio">
                        <span>Absolue</span>
                    </label>
                </p>
            </div>
        </div>
        `+ super.footer();
    }

    getCmyk(color) {
        switch (color) {
            case 'red':
                return this.photoshopController.PSEngine.activeOperation.redAdjust;
            case 'yellow':
                return this.photoshopController.PSEngine.activeOperation.yellowAdjust;
            case 'green':
                return this.photoshopController.PSEngine.activeOperation.greenAdjust;
            case 'cyan':
                return this.photoshopController.PSEngine.activeOperation.cyanAdjust;
            case 'blue':
                return this.photoshopController.PSEngine.activeOperation.blueAdjust;
            case 'magenta':
                return this.photoshopController.PSEngine.activeOperation.magentaAdjust;
            case 'white':
                return this.photoshopController.PSEngine.activeOperation.whiteAdjust;
            case 'neutral':
                return this.photoshopController.PSEngine.activeOperation.neutralAdjust;
            case 'black':
                return this.photoshopController.PSEngine.activeOperation.blackAdjust;
        }
    }

    setCmyk(color, value) {
        switch (color) {
            case 'red':
                this.photoshopController.PSEngine.activeOperation.redAdjust = value;
                break;
            case 'yellow':
                this.photoshopController.PSEngine.activeOperation.yellowAdjust = value;
                break;
            case 'green':
                this.photoshopController.PSEngine.activeOperation.greenAdjust = value;
                break;
            case 'cyan':
                this.photoshopController.PSEngine.activeOperation.cyanAdjust = value;
                break;
            case 'blue':
                this.photoshopController.PSEngine.activeOperation.blueAdjust = value;
                break;
            case 'magenta':
                this.photoshopController.PSEngine.activeOperation.magentaAdjust = value;
                break;
            case 'white':
                this.photoshopController.PSEngine.activeOperation.whiteAdjust = value;
                break;
            case 'neutral':
                this.photoshopController.PSEngine.activeOperation.neutralAdjust = value;
                break;
            case 'black':
                this.photoshopController.PSEngine.activeOperation.blackAdjust = value;
                break;
        }
    }

    sc_colorsOnChange() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.initializeSelectiveCorrectionRange();
        this.photoshopController.update();
    }

    cyan_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        const scColorsElement = document.getElementById("sc-colors");
        let color = (scColorsElement as HTMLSelectElement).value;
        let cmyk = this.getCmyk(color);
        cmyk[0] = Number(value) / 100.0;
        this.setCmyk(color, cmyk);
        this.photoshopController.update();
    }

    magenta_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        const scColorsElement = document.getElementById("sc-colors");
        let color = (scColorsElement as HTMLSelectElement).value;
        let cmyk = this.getCmyk(color);
        cmyk[1] = Number(value) / 100.0;
        this.setCmyk(color, cmyk);
        this.photoshopController.update();
    }

    yellow_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        const scColorsElement = document.getElementById("sc-colors");
        let color = (scColorsElement as HTMLSelectElement).value;
        let cmyk = this.getCmyk(color);
        cmyk[2] = Number(value) / 100.0;
        this.setCmyk(color, cmyk);
        this.photoshopController.update();
    }

    black_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        const scColorsElement = document.getElementById("sc-colors");
        let color = (scColorsElement as HTMLSelectElement).value;
        let cmyk = this.getCmyk(color);
        cmyk[3] = Number(value) / 100.0;
        this.setCmyk(color, cmyk);
        this.photoshopController.update();
    }

    sc_relative_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.useRelative = (value === "relative");
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            const scColorsElement = document.getElementById("sc-colors");
            let color = (scColorsElement as HTMLSelectElement).value;
            const cyanInput = document.getElementById("sc-cyan-input") as HTMLInputElement | null;
            if (cyanInput) {
                cyanInput.valueAsNumber = Math.round(this.getCmyk(color)[0] * 100);
            }
            const magentaInput = document.getElementById("sc-magenta-input") as HTMLInputElement | null;
            if (magentaInput) {
                magentaInput.valueAsNumber = Math.round(this.getCmyk(color)[1] * 100);
            }
            const yellowInput = document.getElementById("sc-yellow-input") as HTMLInputElement | null;
            if (yellowInput) {
                yellowInput.valueAsNumber = Math.round(this.getCmyk(color)[2] * 100);
            }
            const blackInput = document.getElementById("sc-black-input") as HTMLInputElement | null;
            if (blackInput) {
                blackInput.valueAsNumber = Math.round(this.getCmyk(color)[3] * 100);
            }
            if (this.photoshopController.PSEngine.activeOperation.useRelative !== undefined) {
                const element = document.getElementById("sc-relative-input") as HTMLInputElement | null;
                if (element) {
                    element.checked = this.photoshopController.PSEngine.activeOperation.useRelative;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'selectiveCorrection') {
            const colorBalanceElement = document.getElementById("selectiveCorrection");
            if (colorBalanceElement) {
                colorBalanceElement.style.display = "";
            }
        } else {
            const colorBalanceElement = document.getElementById("selectiveCorrection");
            if (colorBalanceElement) {
                colorBalanceElement.style.display = "none";
            }
        }
    }

    initializeSelectiveCorrectionRange() {

        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
                return;
            }
            if (!this.photoshopController.PSEngine.activeOperation) {
                return;
            }

            const scColorsElement = document.getElementById("sc-colors");
            let color = (scColorsElement as HTMLSelectElement).value;

            var cyanRange = document.getElementById("sc-cyan-range");
            if (cyanRange) {
                if (cyanRange.noUiSlider) {
                    cyanRange.noUiSlider.destroy();
                }
                noUiSlider.create(cyanRange, {
                    start: [Math.round(this.getCmyk(color)[0] * 100)],
                    step: 1,
                    range: {
                        min: -100,
                        max: 100
                    }
                });
                if (cyanRange.noUiSlider) {
                    cyanRange.noUiSlider.on('update', function (values, handle) {
                        let cmyk = this.getCmyk(color);
                        cmyk[0] = Number(values[0]) / 100.0;
                        this.setCmyk(color, cmyk);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const cyanInput = document.getElementById('sc-cyan-input');
                if (cyanInput) {
                    cyanInput.addEventListener('change', function (event) {
                        this.cyan_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (cyanRange && cyanRange.noUiSlider) {
                            cyanRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var magentaRange = document.getElementById("sc-magenta-range");
            if (magentaRange) {
                if (magentaRange.noUiSlider) {
                    magentaRange.noUiSlider.destroy();
                }
                noUiSlider.create(magentaRange, {
                    start: [Math.round(this.getCmyk(color)[1] * 100)],
                    step: 1,
                    range: {
                        min: -100,
                        max: 100
                    }
                });
                if (magentaRange.noUiSlider) {
                    magentaRange.noUiSlider.on('update', function (values, handle) {
                        let cmyk = this.getCmyk(color);
                        cmyk[1] = Number(values[0]) / 100.0;
                        this.setCmyk(color, cmyk);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const magentaInput = document.getElementById('sc-magenta-input');
                if (magentaInput) {
                    magentaInput.addEventListener('change', function (event) {
                        this.magenta_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (magentaRange && magentaRange.noUiSlider) {
                            magentaRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var yellowRange = document.getElementById("sc-yellow-range");
            if (yellowRange) {
                if (yellowRange.noUiSlider) {
                    yellowRange.noUiSlider.destroy();
                }
                noUiSlider.create(yellowRange, {
                    start: [Math.round(this.getCmyk(color)[2] * 100)],
                    step: 1,
                    range: {
                        min: -100,
                        max: 100
                    }
                });
                if (yellowRange.noUiSlider) {
                    yellowRange.noUiSlider.on('update', function (values, handle) {
                        let cmyk = this.getCmyk(color);
                        cmyk[2] = Number(values[0]) / 100.0;
                        this.setCmyk(color, cmyk);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const yellowInput = document.getElementById('sc-yellow-input');
                if (yellowInput) {
                    yellowInput.addEventListener('change', function (event) {
                        this.yellow_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (yellowRange && yellowRange.noUiSlider) {
                            yellowRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }

            var blackRange = document.getElementById("sc-black-range");
            if (blackRange) {
                if (blackRange.noUiSlider) {
                    blackRange.noUiSlider.destroy();
                }
                noUiSlider.create(blackRange, {
                    start: [Math.round(this.getCmyk(color)[3] * 100)],
                    step: 1,
                    range: {
                        min: -100,
                        max: 100
                    }
                });
                if (blackRange.noUiSlider) {
                    blackRange.noUiSlider.on('update', function (values, handle) {
                        let cmyk = this.getCmyk(color);
                        cmyk[3] = Number(values[0]) / 100.0;
                        this.setCmyk(color, cmyk);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const blackInput = document.getElementById('sc-black-input');
                if (blackInput) {
                    blackInput.addEventListener('change', function (event) {
                        this.black_inputOnChange((event.currentTarget as HTMLInputElement).value);
                        if (blackRange && blackRange.noUiSlider) {
                            blackRange.noUiSlider.set([(event.currentTarget as HTMLInputElement).value]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeSelectiveCorrectionRange();
    }
}